<app-page-title
	title="Recuperar lista"
	subtitle="Ver nomes apostados"
	breadcrumb="Recuperação"
	subpage="Cadastro"
	(subpageClick)="goToRegister()"
	[loading]="loading"
/>

<section class="page-section container">
	<div class="grid">
		<div class="col-12 sm:col-6">
			<h2>Cadê minha lista?</h2>
			<p>As apostas do Bolão Pé na Cova são privadas. <em>Só você pode ver sua lista</em>.</p>
			<p>
				Para ver os nomes apostados, coloque seu e-mail e você receberá uma mensagem com a sua lista.
				<br/>
				Devido a limitações no servidor, é possível que o e-mail demore até duas horas para chegar.
			</p>
			<p>
				Lembrando que sua lista <em>não pode ser alterada e nem excluída</em>.
			</p>
			<p>
				Qualquer dúvida, <a (click)="goContact()" href="#">entre em contato</a>.
			</p>
		</div>
		<div class="col-12 sm:col-6 recover-form-container">
			<app-recover-form />
		</div>	
	</div>
</section>	
